import { apiFetch, getApiUrl } from './client';

export interface AppearanceProfile {
  [key: string]: number[] | string;
}

export interface AppearanceSample {
  id: number;
  sample_key: string;
  split: string;
  qwen: AppearanceProfile;
  seed: AppearanceProfile;
  gemini: AppearanceProfile;
  diffs: string[];
  field_picks: Record<string, string>;
  picked_model: string;
  qc_status: string;
  qc_by: string;
}

export type DatasetSplit = 'train' | 'test';

export interface AppearanceList {
  offset: number;
  total: number;
  open_total: number;
  passed_total: number;
  open_offset: number;
  split?: string;
  train_total?: number;
  test_total?: number;
  sample: AppearanceSample | null;
}

export function listAppearance(offset: number, split: DatasetSplit | '' = '') {
  const splitQuery = split ? `&split=${split}` : '';
  return apiFetch<AppearanceList>(`/v1/appearance-review/samples?offset=${offset}${splitQuery}`);
}

export function pickAppearance(id: number, fields: Record<string, string>) {
  return apiFetch<{ ok: boolean; picked_model: string }>(`/v1/appearance-review/samples/${id}/pick`, {
    method: 'POST',
    body: JSON.stringify({ fields }),
  });
}

export function appearanceImageUrl(id: number) {
  return getApiUrl(`/v1/appearance-review/samples/${id}/image`);
}
